// @ts-nocheck
import { createMuiTheme } from '@material-ui/core/styles';

const myBlue = '#0b72b9';
const myBlack = '#333';
const myViolet = 'hsla(272, 33%, 55%, 0.9)';

export const mainTheme = createMuiTheme({
  palette: {
    //type: 'dark',
    common: {
      myBlue: `${myBlue}`,
      black: `${myBlack}`,
      myViolet: `${myViolet}`,
    },
    primary: {
      main: `${myBlue}`,
      dark: '#3333',
    },
    secondary: {
      main: `${myBlack}`,
    },
  },
  typography: {
    link: {
      fontFamily: 'Raleway',
      textTransform: 'none',
      fontWeight: 400,
      fontSize: '1.5rem',
      color: 'white',
    },
    mainText: {
      fontFamily: 'Pacifico',
      fontSize: '1rem',
      textTransform: 'none',
      color: 'white',
    },
  },
  page: {
    height: '100%',
    minHeight: '100vh',
    width: '100%',

    color: 'white',
    padding: '4em',
  },
});
